import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { CircularProgress, Grid
} from '@mui/material';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
      },
    flex: {
        flex: 1,
    },
});

class LoadingSpinner extends Component {
    
    render() {
        const classes = this.props.classes;
        return (
            <Grid container className={classes.root} spacing={2} justifyContent="center" style={{marginTop: '40px'}}>
              <Grid item xs={3}>
                <CircularProgress className={classes.progress}
                  color="primary" size={75} thickness={3}/>
              </Grid>
            </Grid>
          );
    }
}
  
export default withStyles(styleSheet)(LoadingSpinner);